import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { ModalContent } from "../../../Shared/components/Modal";
import { SubscriptionsTexts } from "../../Subscriptions/subscriptionsUtils/constsAndEnums";
import Typography from "@mui/material/Typography";
export const ContactUs = ({ altText }) => (_jsx(ModalContent, { children: _jsx(Box, Object.assign({ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", style: { marginBottom: 24 } }, { children: _jsx(Typography, { children: altText ? altText : SubscriptionsTexts.PLEASE_CONTACT_CHANGES }) })) }));
